import { render, staticRenderFns } from "./DomainSettingsPage.vue?vue&type=template&id=7267e210&scoped=true"
import script from "./DomainSettingsPage.vue?vue&type=script&lang=js"
export * from "./DomainSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./DomainSettingsPage.vue?vue&type=style&index=0&id=7267e210&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267e210",
  null
  
)

export default component.exports